export const VISIT_TYPE_CONFIG = {
  visiteur_simple: {
    label: 'Espace ouvert (accès libre)',
    fields: [],
    ndaRequired: false,
  },
  fournisseur: {
    label: 'Fournisseur / Livraison',
    fields: ['supplierCompany', 'svContact'],
    ndaRequired: false,
  },
};
